(() => {
  const STORAGE_KEY = 'foxflowers:favorites';
  const injectProductMobileStyles = () => {
    if (document.getElementById('wff-product-mobile-style')) return;

    const style = document.createElement('style');
    style.id = 'wff-product-mobile-style';
    style.textContent = `
      @media screen and (max-width: 749px) {
        .product-information__media {
          padding: 12px 14px 0;
        }

        .product-information__media media-gallery {
          --gallery-aspect-ratio: 5 / 4 !important;
          --media-radius: 18px !important;
        }

        .product-information__media slideshow-component {
          padding: 8px;
          border: 1px solid rgb(30 56 45 / 0.14);
          border-radius: 24px;
          background: linear-gradient(180deg, #fffaf1 0%, #f7efe3 100%);
          box-shadow: 0 12px 28px rgb(30 56 45 / 0.13);
          overflow: visible;
        }

        .product-information__media :is(slideshow-container, .product-media-container, .product-media, .product-media > *) {
          border-radius: var(--media-radius);
          overflow: hidden;
        }

        .product-information__media .product-media {
          background: rgb(var(--color-background-rgb) / 0.96);
          box-shadow: 0 12px 26px rgb(0 0 0 / 0.1);
        }

        .product-information__media .product-media__image {
          object-fit: cover;
        }

        .product-details .text-block.h3 {
          --padding-block-start: 30px !important;
        }

        .product-details product-price {
          --padding-block-end: 24px !important;
        }

        .product-details variant-picker {
          --padding-block-end: 16px !important;
        }
      }
    `;
    document.head.appendChild(style);
  };
  const selectors = {
    toggle: '[data-wff-favorite-toggle]',
    drawer: '[data-wff-favorites-drawer]',
    list: '[data-wff-favorites-list]',
    empty: '[data-wff-favorites-empty]',
    count: '[data-wff-favorites-count]',
    open: '[data-wff-favorites-open]',
    close: '[data-wff-favorites-close]',
  };

  const readFavorites = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => item && item.id) : [];
    } catch {
      return [];
    }
  };

  const writeFavorites = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('wff:favorites-change', { detail: { items } }));
  };

  const escapeHtml = (value = '') =>
    String(value).replace(/[&<>"']/g, (character) => {
      const entities = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
      };
      return entities[character];
    });

  const getProductFromButton = (button) => ({
    id: button.dataset.productId,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: button.dataset.productPrice,
  });

  const isFavorite = (id, items = readFavorites()) => items.some((item) => item.id === id);

  const setButtonState = (button, active) => {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Elimină de la favorite' : 'Adaugă la favorite');
  };

  const syncButtons = (items = readFavorites()) => {
    document.querySelectorAll(selectors.toggle).forEach((button) => {
      setButtonState(button, isFavorite(button.dataset.productId, items));
    });
  };

  const updateCount = (items = readFavorites()) => {
    document.querySelectorAll(selectors.count).forEach((node) => {
      node.textContent = String(items.length);
      node.hidden = items.length === 0;
    });
  };

  const renderDrawer = (items = readFavorites()) => {
    const list = document.querySelector(selectors.list);
    const empty = document.querySelector(selectors.empty);
    if (!list || !empty) return;

    list.innerHTML = '';
    empty.hidden = items.length > 0;
    list.hidden = items.length === 0;

    for (const item of items) {
      const title = escapeHtml(item.title);
      const price = escapeHtml(item.price);
      const url = escapeHtml(item.url);
      const image = escapeHtml(item.image);
      const row = document.createElement('article');
      row.className = 'wff-favorites__item';
      row.innerHTML = `
        <a class="wff-favorites__media" href="${url}">
          ${image ? `<img src="${image}" alt="${title}" loading="lazy">` : ''}
        </a>
        <div class="wff-favorites__info">
          <a class="wff-favorites__title" href="${url}">${title}</a>
          ${price ? `<p class="wff-favorites__price">${price}</p>` : ''}
        </div>
        <button class="wff-favorites__remove button-unstyled" type="button" data-wff-favorite-remove="${escapeHtml(item.id)}" aria-label="Elimină ${title} de la favorite">
          <span aria-hidden="true">&times;</span>
        </button>
      `;
      list.append(row);
    }
  };

  const refresh = (items = readFavorites()) => {
    syncButtons(items);
    updateCount(items);
    renderDrawer(items);
  };

  const toggleFavorite = (button) => {
    const product = getProductFromButton(button);
    if (!product.id) return;

    const items = readFavorites();
    const exists = isFavorite(product.id, items);
    const nextItems = exists ? items.filter((item) => item.id !== product.id) : [product, ...items];
    writeFavorites(nextItems);
    refresh(nextItems);
  };

  const openDrawer = () => {
    const drawer = document.querySelector(selectors.drawer);
    if (!drawer) return;
    renderDrawer();
    if (typeof drawer.showModal === 'function') drawer.showModal();
    else drawer.setAttribute('open', '');
  };

  const closeDrawer = () => {
    const drawer = document.querySelector(selectors.drawer);
    if (!drawer) return;
    if (typeof drawer.close === 'function') drawer.close();
    else drawer.removeAttribute('open');
  };

  document.addEventListener('click', (event) => {
    const favoriteButton = event.target.closest(selectors.toggle);
    if (favoriteButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleFavorite(favoriteButton);
      return;
    }

    if (event.target.closest(selectors.open)) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest(selectors.close)) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const removeButton = event.target.closest('[data-wff-favorite-remove]');
    if (removeButton) {
      const id = removeButton.dataset.wffFavoriteRemove;
      const nextItems = readFavorites().filter((item) => item.id !== id);
      writeFavorites(nextItems);
      refresh(nextItems);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  window.addEventListener('wff:favorites-change', (event) => refresh(event.detail.items));
  document.addEventListener('DOMContentLoaded', () => {
    injectProductMobileStyles();
    refresh();
  });
  injectProductMobileStyles();
  refresh();
})();
